import { render, staticRenderFns } from "./SidebarSubLink.vue?vue&type=template&id=5ff41f4c"
import script from "./SidebarSubLink.vue?vue&type=script&lang=js"
export * from "./SidebarSubLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports